module.exports = __webpack_public_path__ + "media/images/lp-fukushima12/feature_03-1e2ae4b6fbfe4b090baabcf5f088d6a5.jpg";